<div class="enquiry-page">

<div class="enquiry-container">


<div class="page-header">
     <button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>

<div class="header-icon">

<span class="material-symbols-outlined">
mail
</span>

</div>


<div>

<h1>
Send Enquiry
</h1>

<p>
Contact the service provider directly
</p>

</div>


</div>





<div class="enquiry-card"
*ngIf="service">



<div class="service-box">


<div class="service-icon">

<span class="material-symbols-outlined">
photo_camera
</span>

</div>


<div>

<h2>
{{service.service_name}}
</h2>


<p>
₹ {{service.price}}
</p>


<p>
{{service.duration}}
</p>


</div>


</div>





<label>

Your Message

<span>
*
</span>

</label>



<textarea

[(ngModel)]="message"

placeholder="Write your requirement or questions..."

>
</textarea>




<div class="actions">


<button

(click)="submitEnquiry()"

>


<span class="material-symbols-outlined">
send
</span>

Send Enquiry


</button>


</div>



</div>


</div>


</div>